<template>
  <v-app>
<!--     <v-navigation-drawer
      v-model='commentDrawer'
      v-bind:clipped='true'
      v-bind:right='true'
      v-bind:hide-overlay='true'
      v-bind:disable-resize-watcher='true'
      floating
      app
      >
      <chat-bar></chat-bar>
    </v-navigation-drawer> -->
    <v-toolbar dark fixed app v-bind:clipped-right='true' color='black'>
      <v-toolbar-title>TELLUS</v-toolbar-title>
      <v-spacer></v-spacer>
      Welcome {{name}}
      <v-btn
        v-if='isLoggedIn'
        @click.native='editProfile'
        >
        <v-icon>settings</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      <v-toolbar-items>
      <v-btn
        v-if='!isLoggedIn'
        color='black'
        @click.native='signUp'>
        <v-icon left>edit</v-icon>
        <div class='hidden-sm-and-down'>Sign Up</div>
      </v-btn>
      <v-btn
        v-if='!isLoggedIn'
        color='black'
        @click.native='logIn'>
        <v-icon left>person</v-icon>
        <div class='hidden-sm-and-down'>Log In</div>
      </v-btn>
<!--       <v-btn icon @click.stop="commentDrawer = !commentDrawer"
        v-if='isLoggedIn'
        class="theme--dark secondary"
        >
        <v-icon>speaker_notes</v-icon>
      </v-btn> -->
      <v-btn
        v-if='isLoggedIn'
        color='black'
        @click.native='openProjectsPage'>
        <v-icon left>perm_media</v-icon>
        <div class='hidden-sm-and-down'>Open Project</div>
      </v-btn>
      <v-btn
        v-if='isLoggedIn'
        color='black'
        @click.native='logOut'>
        <v-icon left>person_outline</v-icon>
         <div class='hidden-sm-and-down'>Log Out</div>
      </v-btn>
    </v-toolbar-items>
    </v-toolbar>
    <v-content>
      <v-alert
        v-for='(value, key, index) in alerts'
        :key='key'
        dismissible
        type='error'
        v-model='alertModels[key]'>
        {{key}}
      </v-alert>
          <router-view></router-view>
    </v-content>
    <!-- <tufooter>
    </tufooter> -->
    <v-footer>
      <span>Think Ubiquitous</span>
    </v-footer>
  </v-app>
</template>

<script>
  import tufooter from './components/animations/Footer.vue'
  import chatBar from './components/user/ChatBar.vue'
  import {mapGetters} from 'vuex'
  export default {
    data () {
      return {
        commentDrawer: false,
        alertModels: {}
      }
    },
    components: {
      chatBar, tufooter
    },
    computed: {
      ...mapGetters([
        'alerts',
        'alertCount'
      ]),
      ...mapGetters('user', [
        'user',
        'isLoggedIn'
      ]),
      name () {
        if (this.user !== null) {
          return this.user.name
        } else {
          return null
        }
      }
    },
    created () {
      for (var error in this.alerts) {
        this.$set(this.alertModels, error, true)
      }
    },
    watch: {
      user (value) {
        if (value === null || value === undefined) {
          this.$router.push('/')
        }
      },
      alertModels: {
        handler (val) {
          for (var error in this.alertModels) {
            if (!this.alertModels[error]) {
              this.$store.dispatch('removeAlert', error)
            }
          }
        },
        deep: true
      },
      alerts: {
        handler (val) {
          for (var error in this.alerts) {
            this.$set(this.alertModels, error, true)
          }
        },
        deep: true
      }
    },
    methods: {
      editProfile () {
        this.$router.push({name: 'UserInfo'})
      },
      openProjectsPage () {
        this.$router.push('/projectSelector')
      },
      logIn () {
        this.$router.push('/login')
      },
      signUp () {
        this.$router.push('/signup')
      },
      logOut () {
        this.$store.dispatch('user/logOutUser')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/App.vue